import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLeftLong} from "@fortawesome/free-solid-svg-icons";

function ConfirmSMS(props) {
    const {staff, number, setNumber} = props;
    
    if(staff !== true)
    return (
        <>
        <span>Numer potwierdzający</span>
            <input type="text" name="confirm_nb" value={number} className="confirm-number" onChange={(e) => {setNumber(e.target.value)}}/>
            <div>
                <FontAwesomeIcon className="arrow-left" icon={faLeftLong} />
                <p className="text visable-xs hidden-sm hidden-md hidden-lg col-xs-12">Tutaj wpisz 4 cyfrowy kod, który przesłaliśmy Ci SMS-em </p>
                <div></div>
                <p className="tel-info text hidden-xs">Nie otrzymałeś kodu? Skontaktuj się z nami. Tel. <a className="tel-uri-info" href="tel:+48-503-30-99-11">503 30 99 11</a></p>
            </div>
        </>
    )
}

export default ConfirmSMS;